import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listLlms } from '../../../../../store/actions/promptsv2.action';
import { Spin, Dropdown, Menu } from 'antd';
import { PlusIcon, ActionMenuIcon, EditAppointmentIcon } from 'src/icons';
import { Button } from '../../../../baseComponents';
import { SuperAdminTable } from '../../../../baseComponents/Table';

const ListLLMs = () => {
  const dispatch = useDispatch();
  const { llms, llmsLoading } = useSelector((state) => state?.promptsState);

  const [filters, setFilters] = useState({ page: 1, per_page: 20 });

  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);
  const [editingLlmId, setEditingLlmId] = useState(null);

  useEffect(() => {
    dispatch(listLlms(filters));
  }, [dispatch, filters]);

  const handleEdit = (llmId) => {
    setIsEditModalVisible(true);
    setEditingLlmId(llmId);
  };

  const menuOptions = (id) => {
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'editLlm') {
            handleEdit(id);
          }
        }}
      >
        <Menu.Item key="editLlm">
          <div className="dropdown-text flex items-center space-x-2">
            <EditAppointmentIcon /> <span>Edit LLM</span>
          </div>
        </Menu.Item>
      </Menu>
    );
  };

  const columns = [
    {
      title: <span className="font-[700]">Name</span>,
      dataIndex: 'model',
      key: 'model',
    },
    {
      title: <span className="font-[700]">Provider</span>,
      dataIndex: 'provider',
      key: 'provider',
    },
    {
      title: <span className="font-[700]">Region</span>,
      dataIndex: 'region',
      key: 'region',
    },
    {
      title: <span className="font-[700]">Max Tokens</span>,
      dataIndex: 'max_tokens',
      key: 'max_tokens',
    },
    {
      title: <span className="font-[700]">Model Parameters</span>,
      dataIndex: 'model_kwargs',
      key: 'model_kwargs',
      render: (model_kwargs) => {
        return model_kwargs
          ? JSON.stringify(model_kwargs).substring(0, 30) + '...'
          : '-';
      },
    },
    {
      title: '',
      key: 'actions',
      dataIndex: 'actions',
      render: (text, record) => {
        return (
          <Dropdown
            className=""
            overlay={menuOptions(record?.id || record?.llm_id)}
            trigger={['click']}
          >
            <a className="" onClick={(e) => e.preventDefault()}>
              <ActionMenuIcon />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  const handleTableChange = (pagination) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      page: pagination.current,
      per_page: pagination.pageSize,
    }));
  };

  return (
    <div>
      <div className="mt-5 ant-table rounded-xl shadow-xl">
        <SuperAdminTable
          className={'appointment-page-table'}
          data={llms?.llms || llms?.data || llms}
          columns={columns}
          loading={llmsLoading}
          rowKey="id"
          pagination={{
            total: llms?.total_items || llms?.total,
            pageSize: llms?.per_page,
            current: llms?.page,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            showSizeChanger: true,
            pageSizeOptions: ['20', '50'],
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
};

export default ListLLMs;
